module.exports = __webpack_public_path__ + "static/main-brochure-6ba3af7473e1cfb2dd7ee0a843d491b1.pdf";